import { createTheme } from '@material-ui/core'
import palette from './palette'
import typography from './typography'
import overrides from './overrides'
import form from './form'
import spacing from './spacing'

const baseTheme = {
  spacing,
  palette,
  typography,
  overrides,
  form,
}

export const theme = createTheme(baseTheme)
export const themeWithRtl = createTheme({ ...baseTheme, direction: 'rtl' })
